import type { UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import type { PostInterface } from '../types/post-interface'
import { communityPostKeys } from './key-factory'

export function usePinnedPosts(): UseQueryResult<PostInterface[]> {
  const router = useRouter()
  const { user } = useUser()
  const { communityPath, topicPath } = router.query

  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, PostInterface[]>({
    method: RequestMethodsEnum.get,
    badRequestHandler: () => {},
  })

  return useQuery(
    queryOptions({
      queryKey: communityPostKeys.pinnedList(communityPath, topicPath),
      queryFn: () =>
        fetcher(
          topicPath
            ? `${COMMUNITY_API_PREFIX}/${communityPath}/topic/${topicPath}/posts/pinned`
            : `${COMMUNITY_API_PREFIX}/${communityPath}/posts/pinned`,
        ),
      enabled: Boolean(user && communityPath),
    }),
  )
}
